import { Box, CircularProgress } from "@mui/material";

/**
 * A component that displays a loading spinner while a dialog mutation is pending.
 */
export const DialogMutationPending = () => {
    return (
        <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            flexGrow={1}
        >
            <CircularProgress size={48} thickness={5} />
        </Box>
    );
};
